"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var vue_1 = require("vue");
var PreferencesManager_1 = require("../PreferencesManager");
exports.Button = vue_1.default.component('Button', {
    props: {
        title: {
            type: String,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        align: {
            type: String,
            validator: function (align) { return ['right', 'left'].includes(align); },
        },
        size: {
            type: String,
            default: 'normal',
            validator: function (item) {
                return ['tiny', 'small', 'normal', 'big', 'jumbo'].includes(item);
            },
        },
        rounded: {
            type: Boolean,
            default: true,
        },
        disableOnServerBusy: {
            type: Boolean,
            default: true,
        },
        type: {
            type: String,
            default: 'normal',
            validator: function (item) {
                return [
                    'normal',
                    'action',
                    'max',
                    'success',
                    'error',
                    'submit',
                    'close',
                    'back',
                    'minus',
                    'plus',
                ].includes(item);
            },
        },
        danger: {
            type: Boolean,
            default: false,
        },
        onClick: {
            type: Function,
            default: function () { },
        },
    },
    methods: {
        getOuterClass: function () {
            var classes = ['btn'];
            if (this.size === 'tiny') {
                classes.push('btn-tiny');
            }
            else if (this.size === 'small') {
                classes.push('btn-sm');
            }
            else if (this.size === 'big') {
                classes.push('btn-lg');
            }
            if (this.type === 'max') {
                classes.push('btn-max');
            }
            else if (this.type === 'success') {
                classes.push('btn-success');
            }
            else if (this.type === 'error') {
                classes.push('btn-error');
            }
            else if (this.type === 'action') {
                classes.push('btn-action');
            }
            else if (this.type === 'submit') {
                classes.push('btn-submit');
            }
            if (this.danger) {
                if (!PreferencesManager_1.PreferencesManager.loadBoolean('hide_color_code_buttons')) {
                    classes.push('btn-dangerous');
                }
            }
            if (this.align === 'left') {
                classes.push('float-left');
            }
            else if (this.align === 'right') {
                classes.push('float-right');
            }
            if (this.rounded === true) {
                classes.push('btn-rounded');
            }
            if (this.disableOnServerBusy) {
                if (this.$root.isServerSideRequestInProgress) {
                    classes.push('loading');
                }
            }
            return classes.join(' ');
        },
        getDisabled: function () {
            if (this.disableOnServerBusy) {
                return (this.disabled ||
                    this.$root.isServerSideRequestInProgress);
            }
            return this.disabled;
        },
        getInnerClass: function () {
            switch (this.type) {
                case 'close':
                    return 'icon icon-cross';
                case 'back':
                    return 'icon icon-back';
                case 'plus':
                    return 'icon icon-plus';
                case 'minus':
                    return 'icon icon-minus';
            }
            return '';
        },
    },
    template: "\n        <button v-on:click.prevent=\"onClick\" :class=\"getOuterClass()\" :disabled=\"getDisabled()\" v-i18n>\n          <span v-if=\"getInnerClass() !== ''\" :class=\"getInnerClass()\"></span>\n          <span v-else>{{this.title}}</span>\n        </button>\n    ",
});
//# sourceMappingURL=Button.js.map